import axios from 'axios'
import store from '@/store/index.js'

export const axapi = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api/v1',
    headers: {},
})

export default function setup () {
    axios.interceptors.request.use(function (config) {
        const token = store.getters.bearerToken
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    }, function (err) {
        return Promise.reject(err)
    })

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error)
    })
}
